//Account
export const ACCOUNT_LOGIN_SUCCESS = "ACCOUNT_LOGIN_SUCCESS";
export const ACCOUNT_LOGIN_FAILED = "ACCOUNT_LOGIN_FAILED";
export const ACCOUNT_LOGIN_LOGOUT = "ACCOUNT_LOGIN_LOGOUT";
export const ACCOUNT_UPDATE_STATE = "ACCOUNT_UPDATE_STATE";
export const ACCOUNT_UPDATE_POINTS = "ACCOUNT_UPDATE_POINTS"
export const ACCOUNT_GETDATAUSER_SUCCESS = "ACCOUNT_GETDATAUSER_SUCCESS";
export const ACCOUNT_UPDATE_DATAUSER = "ACCOUNT_UPDATE_DATAUSER";
export const ACCOUNT_UPDATE_TOKEN_GAME ="ACCOUNT_UPDATE_TOKEN_GAME";
export const ACCOUNT_UPDATE_STATE_GAME ="ACCOUNT_UPDATE_STATE_GAME"
export const ACCOUNT_UPDATE_POINTS_COMPRA ="ACCOUNT_UPDATE_POINTS_COMPRA"
export const ACCOUNT_UPDATE_CONTACTO_GAME ="ACCOUNT_UPDATE_CONTACTO_GAME";

export const UI_MENU_SHOW = "UI_MENU_SHOW";
export const UI_MENU_HIDE = "UI_MENU_HIDE";
export const UI_TOAST_UPDATE_SHOW = "UI_TOAST_UPDATE_SHOW";
export const UI_TOAST_UPDATE_HIDE = "UI_TOAST_UPDATE_HIDE";
export const UI_LOADER_SHOW = "UI_LOADER_SHOW";
export const UI_LOADER_HIDE = "UI_LOADER_HIDE";
export const UI_MODAL_LOGIN_SHOW = "UI_MODAL_LOGIN_SHOW"
export const UI_MODAL_LOGIN_HIDE = "UI_MODAL_LOGIN_HIDE"

export const GAME_CHANGE_POINTS = "GAME_CHANGE_POINTS";
export const GAME_CHANGE_TIME = "GAME_CHANGE_TIME";
export const GAME_STATE_GAME = "GAME_STATE_GAME";
export const GAME_STATE_HELP = "GAME_STATE_HELP";
export const GAME_HELP = "GAME_HELP";